import { Link } from "react-router-dom";
import React from "react";

import {
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "../ui/navigation-menu";
import { NavItemProps } from "./types";

const NavItem: React.FC<NavItemProps> = ({ ...props }) => {
  if (props.type === "single") {
    const { href, title } = props;

    return (
      <NavigationMenuItem>
        <NavigationMenuLink href={href} className={navigationMenuTriggerStyle()}>
          {title}
        </NavigationMenuLink>
      </NavigationMenuItem>
    );
  }
  const { title, menuItems } = props;
  const isOddClassName = menuItems.length % 2 !== 0 ? "last:col-span-2" : "";
  return (
    <NavigationMenuItem>
      <NavigationMenuTrigger>{title}</NavigationMenuTrigger>
      <NavigationMenuContent>
        <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
          {menuItems.map((item) => (
            <li key={item.title} className={isOddClassName}>
              <NavigationMenuLink asChild>
                <Link
                  to={item.href}
                  className="h-full block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                >
                  <div className="flex gap-1 text-sm font-medium leading-none">
                    {item.icon}
                    {item.title}
                  </div>
                  <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">{item.description}</p>
                </Link>
              </NavigationMenuLink>
            </li>
          ))}
        </ul>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};

export default NavItem;
